import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import V2SettingsIframe from '@aware/common/v2-settings-iframe';
import { replaceCancelButtonAction } from '@aware/common/v2-settings/helpers';
import useAuth from '@common/hooks/use-auth';
import UtilityBar from '@aware/common/utility-bar';
import PageNotFound from '@common/components/page-not-found';
import { CREATE_STUDENT_INVENTORY_TESTS } from '@rights';
import { V2_ROUTE_PAGES } from '@aware/v2-routes/constants';

const NewStudentInventoryAssessment = () => {
  const history = useHistory();
  const location = useLocation();
  const { checkRights } = useAuth();

  const redirectFn = () => {
    history.push(`${V2_ROUTE_PAGES.authorAssessments}?tab=inventory`);
  };

  useEffect(() => {
    window.top.newStudentInventoryAssessmentCallbackFn = newInventoryAssessmentId => {
      history.push(
        `${V2_ROUTE_PAGES.authorAssessments}/edit/inventory/${newInventoryAssessmentId}`
      );
    };

    return () => delete window.top.newStudentInventoryAssessmentCallbackFn;
  }, [history]);

  const canCreateStudentInventories = checkRights([CREATE_STUDENT_INVENTORY_TESTS]);

  if (!canCreateStudentInventories) {
    return <PageNotFound UtilityBar={UtilityBar} />;
  }
  return (
    <V2SettingsIframe
      iframeSrc="/aware/?embed=1&detailsSrc=/aware/Manage/StudentInventory/NewAssessmentWizard.aspx?embed=1"
      title="New Student Inventory Assessment"
      key={location.key}
      onLoadCallback={iframe => replaceCancelButtonAction({ iframe, redirectFn })}
    />
  );
};

export default NewStudentInventoryAssessment;
